import { decodeFragment, fragmentText } from "@norkron/web-docz";

/**
 * Plain-text preview of a stored comment body, for compact list surfaces (the
 * Tickets queue's row preview, and any future one-line comment preview).
 *
 * A comment body is persisted in one of two forms (rich-comments §5.1):
 *  · `docz-fragment` — a stable-JSON docz fragment (`{"kind":…,"runs":[{"text",
 *    "marks"}…]}`), the WYSIWYG composer's output. Rendering that string verbatim
 *    dumps the raw serialization into the UI (the Tickets-list bug).
 *  · legacy `markdown` — a plain string.
 *
 * This flattens EITHER to human-readable text: a fragment is decoded and reduced
 * to its concatenated run text via web-docz (`decodeFragment` + `fragmentText` —
 * the SAME primitives `CommentBody`'s plain-text fallback uses, so previews and
 * the full thread body agree), a plain string is returned unchanged. Any
 * decode/parse failure falls back to the raw string (never throws), so a
 * malformed body degrades to its literal text instead of breaking the row.
 *
 * Composition, not reimplementation (RULE ZERO): the text extraction lives in
 * web-docz; this thin app helper only owns the "is-it-a-fragment?" guard, which
 * is elaborate's storage concern.
 */
export function commentBodyPreview(body: string | null | undefined): string {
  if (!body) return "";
  // Only a JSON object can be a docz fragment — skip the parse for plain strings.
  if (body.trimStart().charCodeAt(0) !== 0x7b /* '{' */) return body;
  try {
    return fragmentText(decodeFragment(body));
  } catch {
    return body;
  }
}
